import { render, staticRenderFns } from "./stuform.vue?vue&type=template&id=55f28b29&scoped=true&"
import script from "./stuform.vue?vue&type=script&lang=js&"
export * from "./stuform.vue?vue&type=script&lang=js&"
import style0 from "./stuform.vue?vue&type=style&index=0&id=55f28b29&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f28b29",
  null
  
)

export default component.exports